export function tryParse<T>(objString: string): T {
    try {
        if (objString) {
            return JSON.parse(objString);
        }
    } catch (err) {
        console.error(`tryParse: error parsing string ${objString}`);
        return null;
    }
    return null;
}

export function getLoanToValue(loanAmount: number, purchasePrice: number): string {
    const loanToValue = (loanAmount / purchasePrice) * 100;
    return loanToValue.toFixed(2) + "%";
}